import { render, staticRenderFns } from "./Electricians.vue?vue&type=template&id=41cc43ae&scoped=true"
import script from "./Electricians.vue?vue&type=script&lang=js"
export * from "./Electricians.vue?vue&type=script&lang=js"
import style0 from "./Electricians.vue?vue&type=style&index=0&id=41cc43ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cc43ae",
  null
  
)

export default component.exports